import {inject} from 'aurelia-framework';
import Inputmask from 'inputmask';

@inject(Element)
export class MaskCustomAttribute {
    constructor(element) {
        this.element = element;
    }

    bind() {
        Inputmask(this.value, {
          onBeforeMask: (value, opts) => {
            if (this.isDecimalMask(this.element)) {
              const zeroString = this.padZeros(this.element);
              this.element.inputmask._valueSet(zeroString);
              return zeroString;
            }
          }
        }).mask(this.element);
        
        this.element.addEventListener("blur", () => {
          this.element.inputmask.opts.onBeforeMask.call();
        });
  
        if (this.isDecimalMask(this.element) && !this.element.value) {
          this.element.inputmask.setValue(this.padZeros(this.element));
        }        
    }

    padZeros(element) { 
      const maskString = element.inputmask.maskset.mask;
      const stringSections = element.inputmask._valueGet().split('.');
      const maskStringSections = maskString.replaceAll('[9]', '0').split('.');
      let newValue = stringSections[0].padStart(1, '0') + ".";
      if (stringSections[1] != undefined) {
        newValue += stringSections[1].padEnd(maskStringSections[1].length, '0');
      }
      else {
        newValue += '0'.repeat(maskStringSections[1].length);
      }
      return newValue;
    }

    isDecimalMask(element) {
      const maskString = element.inputmask.maskset.mask;
      return maskString.includes('.') && maskString.includes('[');
    }

    isIntMask(element) {
      const maskString = element.inputmask.maskset.mask;
      return !maskString.includes('.') && maskString.includes('[');
    }

}
